import { USERS_TYPE_ID } from 'constants/user';

import { isDefined } from 'services/util/auxiliaryUtils';

import { getBaseURL } from './settings';

/**
 * getUserType
 *
 * @param typeID
 * @returns {string}
 */
export const getUserType = (typeID) => {
    switch (typeID) {
        case USERS_TYPE_ID.MANAGER:
            return 'Manager';
        case USERS_TYPE_ID.USER_SUPERVISOR:
            return 'User Supervisor';
        case USERS_TYPE_ID.AGENT:
            return 'Agent';
        case USERS_TYPE_ID.CHANNEL_SUPERVISOR:
            return 'Channel Supervisor';
        case USERS_TYPE_ID.PARTNER_SUPERVISOR:
            return 'Partner Supervisor';
        default:
            console.log('[ERROR]: USER TAG TRANSLATION MISSING');
            return '';
    }
};

/**
 * isTokenValid
 *
 * @returns {boolean}
 */
export const isTokenValid = () => isDefined(localStorage?.getItem('userToken'));

/**
 * Sends the browser to the ADFS sign-in, or to `uri` when the API gives the page to go to.
 *
 * @param {string | null} [uri]
 */
export function goToAuthADFS(uri = null) {
    let uriAuthADFS = `${getBaseURL()}auth/adfs?redirect_to=${getBaseURL(true)}`;
    // let uriAuthADFS = `${getBaseURL()}auth/adfs?redirect_to=http://localhost:8015`;//DEV
    if (isDefined(uri)) {
        uriAuthADFS = uri;
    }
    return window.location.replace(uriAuthADFS);
}
